module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/clickworker/confirm_en-672efa6c79428d13a76ef214b1b5e94f.gif";